import { NotePencil } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { ReportLifeEventBannerStyled, IconBoxStyled, ButtonBoxStyled } from "./ReportLifeEventBannerStyled";
import { PsButtonTuner } from "stencilSetup";
import { ROUTES } from 'theSource/app/routes';
import { selectLumosEnabled, selectOldEnrollmentUrl } from "theSource/features";

export const ReportLifeEventBanner = () => {
  const { t } = useTranslation('pages.home');
  const navigate = useNavigate();
  const lumosEnabled = useSelector(selectLumosEnabled);
  const oldEnrollmentUrl = useSelector(selectOldEnrollmentUrl);

  const openLifeEvent = () => {
    if ( lumosEnabled ) {
      navigate(`${ROUTES.lifeEvent.path}`);
    } else if (oldEnrollmentUrl) {
      window.location.href = `${oldEnrollmentUrl}/life_event`;
    }
  };

  return (
    <ReportLifeEventBannerStyled data-testid="report-life-event-banner">
      <IconBoxStyled>
        <NotePencil size={48}/>
      </IconBoxStyled>
      <div className="flex-md-fill d-md-flex align-items-center justify-content-between">
        <div className="pl-md-2_5">
          <h3>{t('lifeEvent.title')}</h3>
          <p className="mb-0">{t('lifeEvent.helpText')}</p>
        </div>
        <ButtonBoxStyled>
          <PsButtonTuner
            buttonId="start-life-event-button"
            label={t('lifeEvent.button')}
            level="primary"
            onClick={openLifeEvent}
          />
        </ButtonBoxStyled>
      </div>
    </ReportLifeEventBannerStyled>
  );
};
  